import { ImageVariantType } from "@atoms";
import { PagePaths } from "../../../types";

export const todos: {
  variant: ImageVariantType;
  titleKey: string;
  descriptionKey: string;
  navigationString: string;
  index: number;
}[] = [
  /* {
    variant: "businessInfo",
    title: "Set up your organization",
    description: "",
    navigationString: PagePaths.organization,
  }, */
  {
    variant: "paymentInfo",
    titleKey: "todos.addBillingTitle",
    descriptionKey: "todos.descriptionPlaceholder",
    navigationString: "onboarding-add-card",
    index: 2,
  },
  /* {
    variant: "perksProgram",
    title: "Set up your Perks Program",
    description: "",
    navigationString: PagePaths.perks,
  }, */  
  {
    variant: "newCampaign",
    titleKey: "todos.inviteMemberTitle",
    descriptionKey: "todos.descriptionPlaceholder",
    navigationString: PagePaths.team,
    index: 4,
  },
];

const BlogTypes = {
  bitcoin: "Bitcoin & Crypto"
}

export const blogData: {
  image: string,
  date: string,
  blogTypeText: string,
  title: string;
  description: string;
  blogUrl: string;
}[] = [
  {
    image: "",
    date: "2022-04-30",
    blogTypeText: BlogTypes.bitcoin,
    title: "Bitcoin 101 - What you need to know",
    description: "Bitcoin seems complicated, but don't worry.",
    blogUrl: "https://coinmiles.io/blog/bitcoin-101-what-you-need-to-know",
  },
  {
    image: "",
    date: "2022-04-30",
    blogTypeText: BlogTypes.bitcoin,
    title: "Bitcoin 101 - What you need to know",
    description: "Bitcoin seems complicated, but don't worry.",
    blogUrl: "https://coinmiles.io/blog/bitcoin-101-what-you-need-to-know",
  },
  {
    image: "",
    date: "2022-04-30",
    blogTypeText: BlogTypes.bitcoin,
    title: "Bitcoin 101 - What you need to know",
    description: "Bitcoin seems complicated, but don't worry.",
    blogUrl: "https://coinmiles.io/blog/bitcoin-101-what-you-need-to-know",
  },
  {
    image: "",
    date: "2022-04-30",
    blogTypeText: BlogTypes.bitcoin,
    title: "Bitcoin 101 - What you need to know",
    description: "Bitcoin seems complicated, but don't worry.",
    blogUrl: "https://coinmiles.io/blog/bitcoin-101-what-you-need-to-know",
  },
  {
    image: "",
    date: "2022-04-30",
    blogTypeText: BlogTypes.bitcoin,
    title: "Bitcoin 101 - What you need to know",
    description: "Bitcoin seems complicated, but don't worry.",
    blogUrl: "https://coinmiles.io/blog/bitcoin-101-what-you-need-to-know",
  },
  {
    image: "",
    date: "2022-04-30",
    blogTypeText: BlogTypes.bitcoin,
    title: "Bitcoin 101 - What you need to know",
    description: "Bitcoin seems complicated, but don't worry.",
    blogUrl: "https://coinmiles.io/blog/bitcoin-101-what-you-need-to-know",
  },
];

export const campaigns = [];
